import ServerPage from "./ServerPrice";
import DigitalHumanPrice from "./DigitalHumanPrice";
import CorporationHumanPrice from "./CorporationHumanPrice";
import {Tabs} from "antd";
import styles from "./index.less";

export default function (props) {
  return <Tabs
    className={styles.fullPage}
    centered={true}
    items={[
      {
        key: 'serverPrice',
        label: '服务器套餐',
        children: (
          <div className={styles.tabPaneBox}>
            <ServerPage
              {...props}
            />
          </div>
        ),
      },
      {
        key: 'DigitalHumanPrice',
        label: '数字人席位',
        children: (
          <div className={styles.tabPaneBox}>
            <DigitalHumanPrice
              {...props}
            />
          </div>
        ),
      },
      {
        key: 'CorporationHumanPrice',
        label: '企业成员席位',
        children: (
          <div className={styles.tabPaneBox}>
            <CorporationHumanPrice
              {...props}
            />
          </div>
        ),
      }
    ]}
  />
}